const CallToActionDistribute = () => {
  return (
    <svg viewBox="0 0 1280 369" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="-1280"
        y="-369"
        width="3840"
        height="1107"
        fill="url(#grid-pattern-cta-distribute)"
        transform="translate(2, 22)"
      />
      <rect
        opacity="0.25"
        x="720.785"
        y="224"
        width="40"
        height="40"
        transform="rotate(45 720.785 224)"
        fill="#EB5070"
      />
      <rect x="681" y="92.5" width="39" height="39" stroke="#EB5070" />
      <rect
        x="881"
        y="52.5"
        width="200"
        height="39"
        stroke="#EB5070"
        strokeDasharray="2 2"
      />
      <circle opacity="0.75" cx="900.5" cy="193" r="20" fill="#EB5070" />

      <defs>
        <pattern
          id="grid-pattern-cta-distribute"
          viewBox="0 0 40 40"
          width="1.04166667%"
          height="3.61336947%"
        >
          <rect
            width="40"
            height="40"
            fill="var(--color-background-inverted)"
          />
          <line
            x1="39"
            y1="0"
            x2="39"
            y2="39"
            stroke="var(--brand-color-grey-9)"
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
          <line
            x1="0"
            y1="39"
            x2="39"
            y2="39"
            stroke="var(--brand-color-grey-9)"
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
        </pattern>
      </defs>
    </svg>
  );
};

export default CallToActionDistribute;
